import { useState } from "react";
import * as XLSX from "xlsx";
import { useToasts } from "react-toast-notifications";
import { urlCargarAseguradosExcelAP } from "../../constants/urls";

export const useUploadPlantilla = (slipId, setLoading, setCargaAsegurados) => {
  const { addToast } = useToasts();
  const [resultadoCarga, setResultadoCarga] = useState(null);

  const validarArchivo = (file) => {
    if (!file) {
      addToast("Debe seleccionar un archivo.", { appearance: "error" });
      return false;
    }

    const extension = file.name.split(".").pop().toLowerCase();
    const allowedExtensions = ["xlsx", "xls", "csv"];

    if (!allowedExtensions.includes(extension)) {
      addToast("Archivo no válido. Solo se permiten archivos Excel o CSV.", { appearance: "error" });
      return false;
    }

    return true;
  };

  const leerExcel = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

    return json.map((fila) => {
      const rowLower = {};
      for (const key in fila) {
        if (Object.prototype.hasOwnProperty.call(fila, key)) {
          let cleanKey = key.toLowerCase().trim();
          if (cleanKey.includes('nacimie')) cleanKey = 'fecha de nacimiento';
          if (cleanKey.includes('identificaci')) cleanKey = 'identificacion';
          if (cleanKey.includes('tipo doc')) cleanKey = 'tipo_documento';
          rowLower[cleanKey] = fila[key];
        }
      }

      // let generoVal = String(rowLower["genero"] || rowLower["género"] || "");
      // if (generoVal.toLowerCase().startsWith('m')) generoVal = 'M';
      // else if (generoVal.toLowerCase().startsWith('f')) generoVal = 'F';

      let tipoDocVal = String(rowLower["tipo_documento"] || rowLower["tipo documento"] || rowLower["tipo de documento"] || "");
      if (tipoDocVal.toLowerCase().includes('ced') || tipoDocVal.toLowerCase().includes('céd')) tipoDocVal = 'CED';
      else if (tipoDocVal.toLowerCase().includes('ruc')) tipoDocVal = 'RUC';
      else if (tipoDocVal.toLowerCase().includes('pas')) tipoDocVal = 'PAS';

      let nombreCompleto = String(rowLower["asegurado"] || "").trim().replace(/\s+/g, ' ');
      let parts = nombreCompleto.split(' ');
      let nombres = '';
      let apellidos = '';
      if (parts.length === 1) {
        nombres = parts[0];
      } else if (parts.length === 2) {
        nombres = parts[0];
        apellidos = parts[1];
      } else if (parts.length === 3) {
        nombres = parts[0];
        apellidos = parts[1] + ' ' + parts[2];
      } else if (parts.length >= 4) {
        nombres = parts[0] + ' ' + parts[1];
        apellidos = parts.slice(2).join(' ');
      }

      let pNombre = nombres.split(' ')[0] || '';
      let sNombre = nombres.split(' ').slice(1).join(' ');
      let pApellido = apellidos.split(' ')[0] || '';
      let sApellido = apellidos.split(' ').slice(1).join(' ');

      let fNacRaw = rowLower["fecha de nacimiento"];
      let fNac = String(fNacRaw || "").trim();
      // Excel integer date conversion to YYYY-MM-DD
      if (typeof fNacRaw === 'number') {
        const date = new Date((fNacRaw - 25569) * 86400 * 1000);
        const yyyy = date.getUTCFullYear();
        const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
        const dd = String(date.getUTCDate()).padStart(2, '0');
        fNac = `${yyyy}-${mm}-${dd}`;
      } else if (fNac.includes('/')) {
        let parts = fNac.split('/');
        if (parts.length === 3) {
          fNac = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        }
      }

      let ident = String(rowLower["identificacion"] || "").trim();
      if (tipoDocVal === 'CED' && ident.length === 9) ident = "0" + ident;
      if (tipoDocVal === 'RUC' && ident.length === 12) ident = "0" + ident;

      // let celularVal = String(rowLower["celular"] || rowLower["telefono"] || "").trim();
      // if (celularVal.length === 9) celularVal = "0" + celularVal;

      var errorNombre = false;
      if (/[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]/.test(nombres) || /[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]/.test(apellidos)) {
        errorNombre = true;
      }

      return {
        plan: rowLower["plan"] || "",
        contratante: rowLower["pagador"] || rowLower["contratante"] || "",
        nombre: nombreCompleto,
        identificacion: ident,
        fecha_nacimiento: fNac,
        tipo_documento: tipoDocVal,
        primerNombre: pNombre,
        segundoNombre: sNombre,
        primerApellido: pApellido,
        segundoApellido: sApellido,
        nombres: nombres,
        apellidos: apellidos,
        errorNombre: errorNombre
      };
    }).filter(a => a.plan || a.contratante || a.identificacion || a.nombre);
  };

  const enviarAseguradosAlBackend = async (asegurados) => {

    let url = `${urlCargarAseguradosExcelAP}`;
    const body = {
      id: slipId,
      asegurados: asegurados
    }

    const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
    return await response.json();
  };

  const onUploadPlantilla = async (event) => {
    setLoading(true)
    const file = event.target.files && event.target.files[0];

    if (!validarArchivo(file)) {
      setLoading(false);
      // Resetear el input para permitir re-selección del mismo archivo
      if (event && event.target) event.target.value = "";
      return;
    }

    try {
      const asegurados = await leerExcel(file);
      console.log("Asegurados leídos del Excel:", asegurados);
      console.log("Total asegurados parseados del Excel:", asegurados.length);

      if (!asegurados || asegurados.length === 0) {
        addToast("El archivo no contiene asegurados válidos. Verifique los encabezados y datos del Excel.", { appearance: "warning" });
        setLoading(false);
        if (event && event.target) event.target.value = "";
        return;
      }

      // Separar válidos e inválidos locales
      const validos = asegurados.filter(function(a) { return !a.errorNombre; });

      var result = { transaccion: false, noAgregados: [], mensaje: "" };
      if (validos.length > 0) {
        result = await enviarAseguradosAlBackend(validos);
      } else {
        result.transaccion = true;
      }

      console.log("Resultado carga backend:", JSON.stringify(result));

      if (result.transaccion) {
        // Construir detalle por cada registro del Excel
        var noAgregadosCopy = (result.noAgregados || []).slice();
        var detalle = asegurados.map(function(aseg) {
          if (aseg.errorNombre) {
            return Object.assign({}, aseg, { exitoso: false, motivo: 'Nombres/Apellidos permiten únicamente letras y espacios.' });
          }
          var errorIdx = -1;
          for (var i = 0; i < noAgregadosCopy.length; i++) {
            if (aseg.identificacion && noAgregadosCopy[i].indexOf(aseg.identificacion) !== -1) {
              errorIdx = i;
              break;
            }
          }
          if (errorIdx !== -1) {
            var motivo = noAgregadosCopy.splice(errorIdx, 1)[0];
            return Object.assign({}, aseg, { exitoso: false, motivo: motivo });
          }
          return Object.assign({}, aseg, { exitoso: true, motivo: '' });
        });

        var totalAgregados = detalle.filter(function(d) { return d.exitoso; }).length;
        var totalRechazados = detalle.filter(function(d) { return !d.exitoso; }).length;

        setResultadoCarga({
          total: asegurados.length,
          agregados: totalAgregados,
          rechazados: totalRechazados,
          detalle: detalle
        });

        if (totalRechazados > 0) {
          addToast(totalAgregados + " agregados, " + totalRechazados + " rechazados. Revise el detalle.", { appearance: "warning", autoDismiss: false });
        } else {
          addToast(asegurados.length + " asegurados subidos correctamente.", { appearance: "success" });
        }
        setCargaAsegurados(true);
        setLoading(false)
      } else {
        addToast(result.mensaje || "Error al subir asegurados", { appearance: "error" });
        setLoading(false)
      }
    } catch (error) {
      console.error("Error al procesar el Excel:", error);
      setLoading(false)
      addToast("Error inesperado al procesar el archivo.", { appearance: "error" });
    } finally {
      // Siempre resetear el input para permitir re-selección del mismo archivo
      if (event && event.target) event.target.value = "";
    }
  };

  var cerrarResultado = function() { setResultadoCarga(null); };

  return { subirPlantilla: onUploadPlantilla, resultadoCarga: resultadoCarga, cerrarResultado: cerrarResultado };
};
